// Talen (golf 3, 0033_talen; verzoek oprichter #16; docs/DESIGN.md §8.T): de taalvraag bij de
// onboarding (de eerste vraag), Instellingen · Taal, en een eigen taal per gezinslid en per tablet.
// De namen van de talen staan NIET hier: die staan altijd in hun eigen taal en schrift
// (LOCALE_INFO in locales.ts: Nederlands, English, Türkçe, العربية, Deutsch, Français).
// Toon: je-vorm, korte zinnen, werkwoorden op knoppen.
export const appLanguagesNl = {
    title: 'Taal',
    settingsBody: 'In welke taal jullie de app, de tablets en de e-mails zien',
    // ---- Onboarding: de eerste vraag ----------------------------------------------------------------
    welcomeTitle: 'Welkom. Welke taal spreken jullie thuis?',
    welcomeBody: 'Kies de taal van jullie gezin. Je kunt dit later altijd veranderen bij Instellingen.',
    continue: 'Verder',
    // ---- Instellingen · Taal --------------------------------------------------------------------------
    household: 'Taal van het gezin',
    householdHint: 'Voor de app, de tablets en de e-mails. Ieder gezinslid en elke tablet volgt deze taal, tenzij je iets anders kiest.',
    saved: 'Taal opgeslagen',
    /** Een taal waarvan nog niet alles vertaald is. */
    partial: 'Nog niet alles is vertaald. Wat nog ontbreekt, staat er in het Nederlands.',
    digitsTitle: 'Cijfers',
    digitsLatin: 'Gewone cijfers',
    digitsArabic: 'Arabische cijfers',
    digitsHint: 'Voor tijden en getallen, op de tablets en in de app.',
    overridesTitle: 'Een eigen taal',
    overridesBody: 'Spreekt iemand liever een andere taal, of staat er een tablet op een kamer? Kies dat bij Gezin en bij Tablets.',
    overridesOff: 'Een eigen taal per persoon of tablet staat uit. Je zet het aan bij Modules.',
    toMembers: 'Naar Gezin',
    toDevices: 'Naar Tablets',
    // ---- Per gezinslid en per tablet --------------------------------------------------------------------
    sameAsFamily: 'Zoals het gezin ({language})',
    memberLabel: 'Taal',
    memberHint: 'Voor de app en de e-mails van {name}.',
    deviceLabel: 'Taal van deze tablet',
    deviceHint: 'Handig voor een tablet op een kamer. Anders volgt hij het gezin.',
    deviceSaved: '{name} spreekt nu {language}',
    /** Kort op de kaart van een lid of tablet met een eigen taal. */
    ownLanguage: 'Spreekt {language}',
    // ---- Voor het inloggen --------------------------------------------------------------------------------
    authLabel: 'Taal',
};
//# sourceMappingURL=languagesApp.nl.js.map